var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (true)?_c('div',{staticClass:"line-loading-container"},[_c('div',{staticClass:"loading-line line",style:(("width: " + _vm.size + "px; background: " + _vm.color + ";"))})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }